import type React from "react";
import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "@/shared/components/Toast/ToastNotification";
import { AuthProvider } from "@/shared/contexts/AuthContext";
import { RouteTracker, UserLogProvider } from "@/shared/lib/userLog";

export const AppProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<BrowserRouter>
			<AuthProvider>
				<UserLogProvider>
					<ToastProvider>
						<RouteTracker />
						{children}
					</ToastProvider>
				</UserLogProvider>
			</AuthProvider>
		</BrowserRouter>
	);
};
